/* eslint-disable */
export const UGC_SRC = 'https://www.rei.com/satchel/packages/curalate-ugc/client.js';
export const UGC_API = '/rs/ugc-placement';
